import actions from './actions';

const VoucherModule = {
  namespaced: true,
  actions,
};

export default VoucherModule;
